import { render } from "./ForgetPassword.vue?vue&type=template&id=4a3bcf23&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"

import "./ForgetPassword.vue?vue&type=style&index=0&id=4a3bcf23&lang=css"
import "./ForgetPassword.vue?vue&type=style&index=1&id=4a3bcf23&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3bcf23"]])

export default __exports__